module.exports = __webpack_public_path__ + "img/4,w_1373.73eb217c.jpg";